"use strict";
/**
 * Foreign `<Entity-List>` source helpers (entity libraries).
 * Parse/validate helpers live here; runtime row resolve is in backend `foreignEntityListHydrate`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITY_LIST_SOURCE_PREFIX = void 0;
exports.isValidAdventureId = isValidAdventureId;
exports.parseEntityListSourceAttr = parseEntityListSourceAttr;
exports.collectForeignLibrarySourceIds = collectForeignLibrarySourceIds;
/** Same id rules as backend adventure discovery (top-level or nested slash paths). */
function isValidAdventureId(id) {
    if (!id || id.includes('..') || id.startsWith('/') || id.endsWith('/')) {
        return false;
    }
    return /^[a-z0-9]+(?:[/-][a-z0-9]+)*$/.test(id);
}
exports.ENTITY_LIST_SOURCE_PREFIX = 'adventure:';
/**
 * Parse `source=adventure:<adventureId>` (nested ids allowed, e.g. game-mechanics/field-kit-library).
 * Returns null if missing/empty; `{ ok: false }` if present but invalid.
 */
function parseEntityListSourceAttr(raw) {
    const trimmed = String(raw ?? '').trim();
    if (!trimmed) {
        return null;
    }
    if (!trimmed.toLowerCase().startsWith(exports.ENTITY_LIST_SOURCE_PREFIX)) {
        return {
            ok: false,
            reason: `source must be '${exports.ENTITY_LIST_SOURCE_PREFIX}<adventureId>' (got '${trimmed}')`
        };
    }
    const adventureId = trimmed.slice(exports.ENTITY_LIST_SOURCE_PREFIX.length).trim();
    if (!adventureId) {
        return {
            ok: false,
            reason: `source must include an adventure id after '${exports.ENTITY_LIST_SOURCE_PREFIX}'`
        };
    }
    if (!isValidAdventureId(adventureId)) {
        return {
            ok: false,
            reason: `source adventure id '${adventureId}' is invalid (use lowercase letters, numbers, hyphens; nested with /)`
        };
    }
    return { ok: true, adventureId };
}
function visitRichTextElements(elements, visit) {
    if (!Array.isArray(elements)) {
        return;
    }
    for (const el of elements) {
        if (!el || typeof el !== 'object') {
            continue;
        }
        visit(el);
        if (Array.isArray(el.content)) {
            visitRichTextElements(el.content, visit);
        }
        if (Array.isArray(el.children)) {
            visitRichTextElements(el.children, visit);
        }
        if (Array.isArray(el.elseChildren)) {
            visitRichTextElements(el.elseChildren, visit);
        }
    }
}
function walkSceneRichText(scene, visit) {
    for (const section of scene.sections || []) {
        const desc = section.description;
        if (desc && typeof desc === 'object' && Array.isArray(desc.elements)) {
            visitRichTextElements(desc.elements, visit);
        }
        for (const opt of section.options || []) {
            if (opt.text && typeof opt.text === 'object' && Array.isArray(opt.text.elements)) {
                visitRichTextElements(opt.text.elements, visit);
            }
            if (opt.waitMessage &&
                typeof opt.waitMessage === 'object' &&
                Array.isArray(opt.waitMessage.elements)) {
                visitRichTextElements(opt.waitMessage.elements, visit);
            }
        }
    }
}
/**
 * Collect distinct foreign library adventure ids referenced by `<Entity-List source=…>`
 * embeds in an adventure (for warm/perf scoping and load-time Library:true checks).
 */
function collectForeignLibrarySourceIds(adventure) {
    if (!adventure) {
        return [];
    }
    const ids = new Set();
    const scenes = adventure.scenes || [];
    for (const scene of scenes) {
        walkSceneRichText(scene, el => {
            if (el.type !== 'entity-list') {
                return;
            }
            const parsed = parseEntityListSourceAttr(typeof el.entityListSource === 'string' ? el.entityListSource : undefined);
            if (parsed?.ok) {
                ids.add(parsed.adventureId);
            }
        });
    }
    return [...ids].sort();
}
//# sourceMappingURL=entityListForeign.js.map